var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPasswordKey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-key",
    "data-name": "Icon awesome-key",
    d: "M20,6.875a6.879,6.879,0,0,1-8.157,6.755L10.9,14.685a.937.937,0,0,1-.7.315H8.75v1.562a.937.937,0,0,1-.937.938H6.25v1.563A.937.937,0,0,1,5.313,20H.938A.937.937,0,0,1,0,19.063V16.013a.938.938,0,0,1,.275-.663l6.32-6.32A6.876,6.876,0,1,1,20,6.875ZM13.125,5A1.875,1.875,0,1,0,15,3.125,1.875,1.875,0,0,0,13.125,5Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordKey);
export default __webpack_public_path__ + "static/media/password-key.90519a3b0cf90eca0ebd310e44f52346.svg";
export { ForwardRef as ReactComponent };